import { css } from '@emotion/css'
import { colors, spacing } from '@offerzen/pinata-shame'

const styles = {
  wrapper: css({
    a: {
      color: colors.cornflowerBlue,
      textDecoration: 'none',
    },

    section: {
      marginBottom: spacing.extraLarge,
    },

    'section:first-of-type': {
      marginBottom: spacing.large,
    },
  }),
}

export default styles
